import { HubApiProvider } from "../api";
import { BrandStyleInjector } from "../layout/BrandStyleInjector";
import { AuthGate } from "./AuthGate";
import { InstanceBrandingProvider, useInstanceBrandingQuery } from "./instance-branding";

/**
 * SPA boot sequence. Branding is fetched pre-auth (the endpoint is public) so
 * the sign-in surfaces carry the tenant accent, typeface, and logo; the boot
 * never blocks on it — until the payload lands the default tokens render.
 * `AuthGate` then decides between the auth pages and the portal off
 * `GET /api/me`.
 */
export function HubBoot() {
  return (
    <HubApiProvider baseUrl={import.meta.env.VITE_HUB_API_BASE_URL}>
      <BrandedBoot />
    </HubApiProvider>
  );
}

function BrandedBoot() {
  const branding = useInstanceBrandingQuery();

  return (
    <InstanceBrandingProvider branding={branding.data}>
      {branding.data ? (
        <BrandStyleInjector
          branding={{
            accentColor: branding.data.accentColor,
            logoUrl: branding.data.logoUrl,
            typefaceId: branding.data.typefaceId,
          }}
        />
      ) : null}
      <AuthGate />
    </InstanceBrandingProvider>
  );
}
